export const ENV = 'prod'
export const GENERIC_URL = {
  local: {
    api: 'http://192.168.110.150:6699/',
  },
  dev: {
    api: 'https://web-api-sit.ambslot-api.com/'
  },
  uat: {
    api: 'https://web-api-uat.ambslot-api.com/',
  },
  prod: {
    api: 'https://web-api-prod.ambslot-api.com/'
  }
}
export const GENERAL_URL = {
  local: {
    api: 'http://192.168.110.150:6699/',
  },
  dev: {
    api: 'https://sit.ambslot-api.com/'
  },
  uat: {
    api: 'https://uat.ambslot-api.com/',
  },
  prod: {
    api: 'https://prod.ambslot-api.com/'
  }
}
export const BASE_URL = GENERIC_URL[ENV].api
export const API_URL = GENERAL_URL[ENV].api
export const M_GET = 'GET'
export const M_POST = 'POST'
export const M_PUT = 'PUT'

export const WINLOSE_RESULT = 'result/fetch'
export const GET_GAME = 'result/fetchgame'
export const WP = 'whitelabel'